import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markRead = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };

  const filtered = items.filter((i) => filter === "all" ? true : !i.read);

  return (
    <div className="space-y-6" data-testid="notifs-root">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Inbox</div>
          <h1 className="font-display text-4xl font-bold tracking-tight">{t("notifications")}</h1>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="filter-all" onClick={() => setFilter("all")} className={`px-3 py-1.5 text-xs uppercase tracking-wider border ${filter === "all" ? "klein-blue border-[#002FA7]" : "bg-white border-zinc-300"}`} style={{borderRadius: 2}}>{t("all")}</button>
          <button data-testid="filter-unread" onClick={() => setFilter("unread")} className={`px-3 py-1.5 text-xs uppercase tracking-wider border ${filter === "unread" ? "klein-blue border-[#002FA7]" : "bg-white border-zinc-300"}`} style={{borderRadius: 2}}>{t("unread")}</button>
          <button data-testid="mark-all-read" onClick={markAll} className="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-zinc-300 hover:bg-zinc-50" style={{borderRadius: 2}}>
            <CheckCheck size={12}/> {t("mark_all_read")}
          </button>
        </div>
      </div>

      <div className="swiss-card divide-y divide-zinc-100">
        {filtered.length === 0 && <div className="p-8 text-zinc-500 text-sm text-center">{t("no_data")}</div>}
        {filtered.map((n) => (
          <div key={n.id} onClick={() => !n.read && markRead(n.id)} className={`p-4 flex items-start gap-3 cursor-pointer hover:bg-zinc-50 ${!n.read ? "bg-blue-50/40" : ""}`} data-testid={`notif-${n.id}`}>
            <div className={`mt-1 w-2 h-2 rounded-full ${n.read ? "bg-zinc-300" : "bg-[#E63946]"}`}></div>
            <Bell size={14} className="mt-0.5 text-zinc-400"/>
            <div className="flex-1 min-w-0">
              <div className="text-sm">{n.message}</div>
              <div className="text-xs text-zinc-500">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
